/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54135086
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filter, find, propEq } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import * as HabitCard from '@components/LibraryToDoHabit';
import * as HabitScheduleCard from '@components/LibraryToDoHabitSchedule';
import * as QuotaCard from '@components/LibraryToDoQuota';
import * as Scorecard from '@components/LibraryToDoScoreCard';
import { AppActions, DevelopActions } from '~/actions';
import { ToDoTypes } from '~/services/config';
import withNavigate from '~/hocs/withNavigate';

class ToDoEdit extends React.Component {
    constructor(props) {
        super(props);
        const type = props.match?.params?.activeTab;
        const id = Number(props.match?.params?.id || 0);
        this.state = { id, type };

        if (type === 'scorecards') {
            const detail = find(propEq('id', id), props.templates[type].data);
            const templateIds = detail.data.quotas.map((quota) => quota.quota_template_id);
            templateIds.length > 0 && props.getQuotas(id, type, templateIds);
        }
    }

    handleSelectMenu = (e) => {
        const { type, id } = this.state;
        const { templates } = this.props;
        const disabled = filter((x) => x !== type, ToDoTypes);
        const card = find(propEq('id', id), templates[`${type}`].data);

        switch (e) {
            case 'detail view':
                this.props.navigate(`/library/to-do/${type}/${id}/view`);
                break;
            case 'assign':
                if (type === 'scorecards') {
                    this.props.toggleModal({
                        type: 'Assign ScoreCard',
                        data: { before: { modules: [card], disabled }, after: [] },
                    });
                } else {
                    this.props.toggleModal({
                        type: 'Assign ToDo',
                        data: { before: { modules: [card], disabled }, after: [] },
                    });
                }
                break;
            case 'delete':
                this.props.toggleModal({
                    type: 'Confirm',
                    data: {
                        before: {
                            title: 'Delete',
                            body: 'Are you sure you want to delete this item?',
                        },
                    },
                    callBack: {
                        onYes: () => this.handleDeleteTemplate(id),
                    },
                });
                break;
            default:
                break;
        }
    };

    handleDeleteTemplate = (id) => {
        const { type } = this.state;
        let route = null;
        let target = 'template';
        if (type === 'tracks') {
            target = 'track';
        } else if (type === 'quotas') {
            route = '/library/quotas';
            target = 'quota_template';
        } else if (type === 'scorecards') {
            target = 'scorecard';
        }

        this.props.deleteTemplate(target, 'delete', id, null, route, {
            type: 'GETLIBRARYTEMPLATESSEARCH_REQUEST',
            target: type,
            payload: { page: 1, perPage: 25 },
        });
    };

    handleSubmit = (e) => {
        this.props.saveScorecard(e);
    };

    render() {
        const { role, templates, userId, currentCompanyInfo, authors, departments, categories, competencies, modalData } = this.props;
        const { id, type } = this.state;
        const detail = find(propEq('id', id), templates[type].data);


        return (
            <ErrorBoundary>
                {type === 'habits' && (
                    <HabitCard.Edit
                        userRole={role}
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        data={detail}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        userId={userId}
                        companyId={currentCompanyInfo.id}
                        onSelect={this.handleSelectMenu}
                        onUpdate={(e) => this.props.saveTemplate(e)}
                    />
                )}
                {type === 'habitslist' && (
                    <HabitScheduleCard.Edit
                        userRole={role}
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        data={detail}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        userId={userId}
                        companyId={currentCompanyInfo.id}
                        modalData={modalData}
                        onUpdate={(e) => this.props.saveTemplate(e)}
                        onSelect={this.handleSelectMenu}
                        onModal={(e) => this.props.toggleModal(e)}
                    />
                )}
                {type === 'quotas' && (
                    <QuotaCard.Edit
                        userRole={role}
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        data={detail}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        userId={userId}
                        companyId={currentCompanyInfo.id}
                        onUpdate={(e) => this.props.saveTemplate(e)}
                        onSelect={this.handleSelectMenu}
                    />
                )}
                {type === 'scorecards' && (
                    <Scorecard.Edit
                        userRole={role}
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        data={detail}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        userId={userId}
                        companyId={currentCompanyInfo.id}
                        modalData={modalData}
                        onSubmit={this.handleSubmit}
                        onSelect={this.handleSelectMenu}
                        onModal={(e) => this.props.toggleModal(e)}
                    />
                )}
            </ErrorBoundary>
        );
    }
}

ToDoEdit.propTypes = {
    role: PropTypes.number,
    admin: PropTypes.bool,
    templates: PropTypes.any,
    companyId: PropTypes.number,
    authors: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    categories: PropTypes.array,
    toggleModal: PropTypes.func,
    saveTemplate: PropTypes.func,
    getQuotas: PropTypes.func,
};

ToDoEdit.defaultProps = {
    role: 1,
    admin: false,
    companyId: 0,
    authors: [],
    departments: [],
    competencies: [],
    categories: [],
    scorecardsTags: [],
    templates: {},
    getQuotas: () => {},
    saveTemplate: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    role: state.app.app_role_id,
    userId: state.app.id,
    currentCompanyInfo: state.app.company_info,
    admin: state.app.app_role_id < 3,
    templates: state.develop.templates,
    companyId: state.app.company_info.id,
    authors: state.app.authors,
    departments: state.app.departments,
    competencies: state.app.competencies,
    categories: state.app.categories,
    modalData: state.app.modalData,
});

const mapDispatchToProps = (dispatch) => ({
    getQuotas: (id, type, templateIds) => dispatch(DevelopActions.quotatemplatesRequest(id, type, templateIds)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
    saveScorecard: (e) => dispatch(DevelopActions.postscorecardsaveRequest(e)),
    saveTemplate: (e) => dispatch(DevelopActions.librarysaveRequest(e)),
});

const ToDoEditWithNavigate = withNavigate(ToDoEdit);

export default connect(mapStateToProps, mapDispatchToProps)(ToDoEditWithNavigate);
